import { render, staticRenderFns } from "./radio-select.vue?vue&type=template&id=f8c89dfa&scoped=true&"
import script from "./radio-select.vue?vue&type=script&lang=js&"
export * from "./radio-select.vue?vue&type=script&lang=js&"
import style0 from "./radio-select.vue?vue&type=style&index=0&id=f8c89dfa&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f8c89dfa",
  null
  
)

export default component.exports